import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-snowflake-details',
  templateUrl: './help-snowflake-details.component.html',
  styleUrls: ['./help-snowflake-details.component.scss']
})
export class HelpSnowflakeDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
